import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2918ef61"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"height":"16px","width":"20%"},
  class: "skeleton-elem mb15 mt35"
}, null, -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div style=\"display:flex;\" data-v-2918ef61><div style=\"width:30%;height:180px;\" class=\"skeleton-elem\" data-v-2918ef61></div><div style=\"width:50%;margin-left:30px;padding-top:40px;padding-bottom:40px;\" data-v-2918ef61><div style=\"height:25px;margin-bottom:5px;\" class=\"skeleton-elem\" data-v-2918ef61></div><div style=\"height:15px;width:80%;\" class=\"skeleton-elem\" data-v-2918ef61></div><div style=\"height:15px;width:50%;margin-top:20px;\" class=\"skeleton-elem\" data-v-2918ef61></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item,
        class: "skeleton-block mb30"
      }, _hoisted_3))
    }), 128 /* KEYED_FRAGMENT */))
  ], 64 /* STABLE_FRAGMENT */))
}